export const CASH = 'CASH';
export const CHEQUE = 'CHQ';
export const CREDIT_CARD = 'CRD';
export const DIRECT_CREDIT = 'DC';
export const EFT_POS = 'EFT';
export const ONLINE_CREDIT_CARD = 'OCRD';
export const CREDIT_CARD_STAFF = 'SCRD';
